<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Rekap Absen Siswa'">
          <template v-slot:body>
            <div class="row color-font" style="height: 50px; font-size: larger; border-top: 2px solid; border-bottom: 2px solid; margin-top: 1%;">
              <div class="col-md-6 col-sm-6 col-12">
                <p class="mb-0" style="color: #485377; font-weight: 600;">{{ name }}</p>
              </div>
                
              <div class="col-md-6 col-sm-6 col-12">
                <p class="mb-0 text-right" style="color: #485377; font-weight: 600;">{{ program_name }} / {{ nama_kelompok }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 pb-0">
                <b-form-group label-cols="4" label-cols-lg="4" label="Semester">
                  <Select2 v-model="semester" :options="optSemester" @change="getData" />
                </b-form-group>
              </div>
            </div>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
              <template v-slot:item.no="{ item }">
                  {{ item.no }}
                </template>
              <!-- <template v-slot:item.action="{ item }">
                <router-link :to="{ path: `form-student-list/`, params: { item: JSON.stringify(item) } }">
                  <b-button class="btn-mhs" style="background-color: orange;" size="x-small" v-b-tooltip.hover title="Edit" >
                    <b-icon icon="pencil-square" font-scale="1.5" style="color: white;;"></b-icon>
                  </b-button>
                </router-link>
              </template> -->
            </v-data-table>
          </template>
        </KTCodePreview>

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// import SelectComponent from "@/view/content/components/select/SelectComponent.vue";

export default {
  data() {
    return {
      data : [],
      search: "",
      headers: [
        { text: "No", value: "no", class: "header-color" },
        { text: "Mata Kuliah", value: "course_name", class: "header-color" },
        { text: "Kode Mata Kuliah", value: "course_code", class: "header-color" },
        { text: "Jumlah", value: "jumlah", class: "header-color" },
        { text: "Presentase", value: "persentase", class: "header-color" }
      ],
      param: null,
      depan: false,
      props: this.$route.params.item
        ? JSON.parse(this.$route.params.item)
        : null,
      key : null,
      nama_kelompok: null,
      name: null,
      program_name: null, 
      semester: null,
      optSemester:[
        { "id": 1, "text": 1 },
        { "id": 2, "text": 2 },
        { "id": 3, "text": 3 },
        { "id": 4, "text": 4 },
        { "id": 5, "text": 5 },
        { "id": 6, "text": 6 },
        { "id": 7, "text": 7 },
        { "id": 8, "text": 8 }
      ]
    };
  },
  components: {
    // SelectComponent,
    KTCodePreview
  },
  computed: {
    uuid_siswa() {
        return this.$route.params != null ? this.$route.params.key : null;
    },
    },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Rekap" },
      { title: "Absen Siswa" }
    ]);
    if (this.props !== null) {
      this.key = this.props.key
      this.nama_kelompok = this.props.nama_kelompok
      this.name =  this.props.name
      this.program_name =  this.props.program_name
      this.semester =  this.props.semester
      if (this.semester == 0) {
        this.semester = 1
      } 
      this.getData()
    }
  },
  methods: {
    async getData() {
      if (this.data.length >0) {
        this.data = [];
      }
      const result = await axios.get(`master/attendance/list-siswa/recap-detail/${this.key}/${this.semester}`)
      result.data.data.map((e, index) => {
        var obj = {
          key: e.key_student,
          no: index + 1,
          course_name: e.course_name,
          course_code: e.course_code,
          jumlah: e.absen + "/" + e.jumlah_pertemuan,
          persentase: e.persentase +"%",
        };
        this.data.push(obj);
        return e.length > index;
      });
    },

  }
}
</script>
<style>
.header-color {
  background-color: #3751E4 !important;
  color: white !important;
}
</style>